var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-error-alert"},[_c('img',{staticClass:"c-error-alert__icon",attrs:{"src":_vm.$options.redAlertSVG,"alt":"Red caution symbol"}}),_c('div',{staticClass:"c-error-alert__message"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }